module.exports = __webpack_public_path__ + "img/house-milton-grove_b1.62629742.jpg";